import React, { Component } from 'react';
import TitleWithIcon from '../../TitleWithIcon';
import './index.css';

class CardSection extends Component {
  constructor(props) {
    super(props);
    this.state = {}
    this.downloadTariffsPDFClickHandler = this.downloadTariffsPDFClickHandler.bind(this);
  }

  downloadTariffsPDFClickHandler(){
    // var link = document.createElement("a");
    // link.download = 'خدمات و تعرفه وب سرویس پویا-98';
    // link.href = 'خدمات و تعرفه وب سرویس پویا-98.pdf';
    // link.click();
  }



  render() {
    const { lang , content} = this.props;
    const { header } = content.rightSection
    return (
      <div className='wa-pg-sca-container'>
        {/* <div className='wa-pg-sca-content-wrapper'>
          <div className='wa-pg-sca-content-left'>
            <div>
              {
                content.leftTopSection.map((item,index)=>{
                  const { h1Title, firstParagraph, secondParagraph, iconName, colorClass } = item;
                  return(
                    <TitleWithIcon key={item+index} h1Title={h1Title} firstParagraph={firstParagraph} secondParagraph={secondParagraph}
                      iconName={iconName} colorClass={colorClass} lang={lang} />
                  )
                })
              }
            </div>
            <div className='sc-pricing-page-info-pdf-file-container'>
              <div className='sc-pricing-page-info-pdf-file'>
                <div className='sc-pricing-page-info-pdf-file-wrapper' style={{flexDirection:lang==='fa'? 'row':'row-reverse'}}
                  onClick={this.downloadTariffsPDFClickHandler}>
                  {/* <img alt='' src={require('../../../../assets/images/pdf.svg')}/>
                  {lang==='fa'? <div><span>تعرفه ها</span><span> PDF</span><span> دانلود فایل</span></div> :
                    <div><span>Download</span><span> PDF</span><span> Tariffs File</span></div>
                  } }
                </div >
              </div>
            </div>
          </div>
          <div className='wa-pg-sca-content-right'>
            <h1 style={{direction:lang==='fa'?'rtl':'ltr'}}>{ lang==='fa'?header.fa : header.en} </h1>
            {
              content.rightSection.items.map((item,index)=>{
                const { title, firstParagraph, iconName, colorClass } = item;
                return(
                  <TitleWithIcon key={item+index} title={title} firstParagraph={firstParagraph}
                    iconName={iconName} colorClass={colorClass} lang={lang} iconSize={35} />
                )
              })
            }
            </div>
        </div> */}
      </div>
    );
  }
}




export default CardSection;
